// src/components/ZohoSalesIQ.tsx
import { useEffect } from "react";

const ZohoSalesIQ = () => {

  useEffect(() => {

    const loadZoho = () => {

      if (document.getElementById("zsiqscript")) return;

      const zohoScript = document.createElement("script");
      zohoScript.type = "text/javascript";
      zohoScript.id = "zsiqchat";

      zohoScript.innerHTML = `
        var $zoho = $zoho || {};
        $zoho.salesiq = $zoho.salesiq || {
          widgetcode: "siqca941a9fb83d3f70b5d28f908aa4b2eaac56fc9eedf1c368af8e36b4c2846ea2",
          values: {},
          ready: function() {}
        };
      `;


      const script = document.createElement("script");
      script.type = "text/javascript";
      script.defer = true;
      script.id = "zsiqscript";
      script.src = "https://salesiq.zohopublic.in/widget";


      document.body.appendChild(zohoScript);
      document.body.appendChild(script);
    };


    const checkConsentAndLoad = () => {
      if (
        window.Cookiebot &&
        window.Cookiebot.consent &&
        window.Cookiebot.consent.preferences
      ) {
        loadZoho();
      }
    };


    // Cookiebot already loaded
    checkConsentAndLoad();


    // Cookiebot accept event
    window.addEventListener(
      "CookiebotOnAccept",
      checkConsentAndLoad
    );


    return () => {
      window.removeEventListener(
        "CookiebotOnAccept",
        checkConsentAndLoad
      );
    };

  }, []);


  return null;
};

export default ZohoSalesIQ;